import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

let o = {
  ClientCertificate: false,
  ClientCertificateFindValue: "",
  EndpointAddress: "",
  EndpointName: "",
  Id: null,
  IsValid: false,
  MDNForward: false,
  OrganizationId: null,
  SchemaValidateRequest: false,
  SchemaValidateResponse: false,
  SchemaValidatorOn: false,
  UseConfigFile: false,
  SendXDMBody: false,
};
const XdrSetting = () => {
  const navigate = useNavigate();
  const { userToken, sharedObject, setXDRArr, SetSharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      setXDRArr: state.setXDRArr,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);
  const [comfirmFlag, SetComfirmFlag] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const [flag, SetFlag] = useState(false);
  useEffect(() => {
    const getXDR = async (obj) => {
      let dt = obj;
      let ob = {
        ClientCertificate: dt.clientCertificate,
        ClientCertificateFindValue: dt.clientCertificateFindValue,
        EndpointAddress: dt.endpointAddress,
        EndpointName: dt.endpointName,
        Id: dt.id,
        IsValid: dt.isValid,
        MDNForward: dt.mdnForward,
        OrganizationId: dt.organizationId,
        SchemaValidateRequest: dt.schemaValidateRequest,
        SchemaValidateResponse: dt.schemaValidateResponse,
        SchemaValidatorOn: dt.schemaValidatorOn,
        UseConfigFile: dt.useConfigFile,
        SendXDMBody: dt.sendXDMBody,
      };
      await setAnswers(ob);
    };
    let obj = sharedObject.xdrSettiingObj;
    if (obj?.id) {
      SetFlag(true);
      getXDR(obj);
    } else {
      updateAnswers();
    }
  }, [sharedObject.xdrSettiingObj]);
  const updateAnswers = async () => {
    SetFlag(false);
    await setAnswers(o);
  };

  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };

  const resetValues = async () => {
    let dt = sharedObject.xdrSettiingObj;
    if (!dt?.id) {
      updateAnswers();
    } else {
      let ob = {
        ClientCertificate: dt.clientCertificate,
        ClientCertificateFindValue: dt.clientCertificateFindValue,
        EndpointAddress: dt.endpointAddress,
        EndpointName: dt.endpointName,
        Id: dt.id,
        IsValid: dt.isValid,
        MDNForward: dt.mdnForward,
        OrganizationId: dt.organizationId,
        SchemaValidateRequest: dt.schemaValidateRequest,
        SchemaValidateResponse: dt.schemaValidateResponse,
        SchemaValidatorOn: dt.schemaValidatorOn,
        UseConfigFile: dt.useConfigFile,
        SendXDMBody: dt.sendXDMBody,
      };
      await setAnswers(ob);
    }
  };
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const UpadateXdr = async () => {
    SetFrmSubmFlag(true);
    if (!answers?.EndpointName) {
      document.getElementById("EndpointName").scrollIntoView();
      document.getElementById("EndpointName").focus();
      return;
    } else if (!answers?.EndpointAddress) {
      document.getElementById("EndpointAddress").scrollIntoView();
      document.getElementById("EndpointAddress").focus();
      return;
    }
    SetProcessing(true);
    let call = "/organization/updateXDRConfiguration?orgId=";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      getXDREndPoints();
      SetFrmSubmFlag(false);
      if (res.data.data.id) SetSharedObject("xdrAdded", res.data.data.id);
      //setAnswers({ ...answers, SendXDMBody: false, MDNForward: false });
      setAnswers(o);
      $("#xdrSettingModal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const DeleteXDRConfiguration = async () => {
    SetProcessing(true);
    let call =
      "/organization/deleteXDRConfigurationById?configId=" + answers.Id;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetComfirmFlag(false);
      SetProcessing(false);
      getXDREndPoints();
      $("#xdrSettingModal").modal("hide");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  return (
    <div className="XdrSetting">
      <div
        className="modal fade"
        id="xdrSettingModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="xdr Setting Modal"
        //aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                XDR Setting Configuration
                {/*{comfirmFlag*/}
                {/*  ? `Delete ${answers.EndpointName}?`*/}
                {/*  : "XDR Setting"}*/}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {comfirmFlag ? (
                <div className="modal-content-form ">
                  <p className="descript2-container">
                    This Outbound XDR configuration will be deleted from all
                    organizations.
                  </p>
                  <p class="ft-wt blk-clr ctr field-wrapper">
                    Are you sure you want to delete {answers.EndpointName}?
                  </p>
                </div>
              ) : (
                <div className="modal-content-form">
                  <div className="field-wrapper">
                    <input
                      className="form-control spacer-margin5"
                      type="checkbox"
                      id="UseConfigFile"
                      checked={answers.UseConfigFile}
                      value={answers.UseConfigFile}
                      onChange={(el) =>
                        setAnswer("UseConfigFile", el.target.checked)
                      }
                    />
                    <label>Use Config file</label>
                  </div>
                  <div className="field-wrapper">
                    <label for="EndpointName">
                      Configuration Endpoint Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={answers.EndpointName}
                      disabled={answers.EndpointName && flag}
                      id="EndpointName"
                      onChange={(el) =>
                        setAnswer("EndpointName", el.target.value)
                      }
                    />
                  </div>
                  {!answers?.EndpointName && frmSubmFlag ? (
                    <div className="alert alert-danger" role="alert">
                      Configuration Endpoint Name is required
                    </div>
                  ) : null}
                  <div className="field-wrapper">
                    <label for="EndpointAddress">Endpoint URL</label>
                    <input
                      type="text"
                      className="form-control"
                      id="EndpointAddress"
                      disabled={answers.UseConfigFile}
                      value={answers.EndpointAddress}
                      onChange={(el) =>
                        setAnswer("EndpointAddress", el.target.value)
                      }
                    />
                  </div>
                  {!answers.EndpointAddress && frmSubmFlag ? (
                    <div className="alert alert-danger" role="alert">
                      {" "}
                      Endpoint URL is required{" "}
                    </div>
                  ) : null}
                  <div className="field-wrapper">
                    <label for="ClientCertificateFindValue">
                      {" "}
                      Use Certificate{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Optional"
                      disabled={answers.UseConfigFile}
                      value={answers.ClientCertificateFindValue}
                      onChange={(el) =>
                        setAnswer("ClientCertificateFindValue", el.target.value)
                      }
                    />
                  </div>
                  <div className="field-wrapper">
                    <section>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        value={answers.SendXDMBody}
                        checked={answers.SendXDMBody}
                        onChange={(el) =>
                          setAnswer("SendXDMBody", el.target.checked)
                        }
                      />
                      <label>Deliver message body for XDM messages</label>
                    </section>
                    <section>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        value={answers.MDNForward}
                        checked={answers.MDNForward}
                        onChange={(el) =>
                          setAnswer("MDNForward", el.target.checked)
                        }
                      />
                      <label>Deliver MDNs</label>
                    </section>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              {/*{processing ? (*/}
              {/*  <div className="spacer-inline">*/}
              {/*    <div className="reverse-spinner spinner1"></div>*/}
              {/*    <div className="spacer-inline spacer-margin2 dg-clr">*/}
              {/*      Processing...*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*) : null}*/}
              {processing ? <div className="loading"></div> : null}
              {comfirmFlag ? (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => DeleteXDRConfiguration()}
                  >
                    Comfirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={(e) => SetComfirmFlag(false)}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={UpadateXdr}
                  >
                    {flag ? "Update" : "Add"}
                  </button>
                  {flag ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => SetComfirmFlag(true)}
                    >
                      Delete
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                    onClick={() => resetValues()}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XdrSetting;
